module.exports = __webpack_public_path__ + "assets/dangao.7a8d2abe.svg";